import React, { Component } from "react";
import {
  Button,
  Space,
  Col,
  message,
  Form,
  Input,
  Row,
  Select,
  Upload,
  Spin,
  DatePicker,
  Radio
} from "antd";
import "./Form.css";
import { UploadOutlined } from "@ant-design/icons";
import { observer } from "mobx-react";
import config from "../config";
import CreditStore from "../store/CreditStore";
import { StoreContext } from "../store/RootStore";
import withRouter from "../withRouter";
import Cookies from "universal-cookie";
import dayjs from "dayjs";

const layout = {
  labelCol: { span: 23 },
  wrapperCol: { span: 30 },
};
const { Option } = Select;
class CreditRequestAdd extends Component {
  formRef = React.createRef();

  constructor(props) {
    super(props);
    this.state = {
      companyId: "",
      loadList: 0,
      offset: "",
      limit: "",
      searchField: "",
      creditType: "",
      getRolesList: [],
      departmentId: "",
      userId: -1,
      fileList: [],
      showDeptForm: false,
      loading: false,
      isadmin: 0,
      userType: 1,
      loadingSpin: false,
      disabledField: false,

      submitAction: null,
      paymentDate: dayjs().startOf("day"),
      bankSelected: "",
    };

    this.creditQuantity = [25, 50, 75, 100, 150, 200, 250, 300, 350, 400, 450, 500];
    this.creditStore = new CreditStore();

    // this.selectDepartment = this.selectDepartment.bind(this);
    this.cookies = new Cookies();
    this.handleChange = this.handleChange.bind(this);
    this.selectCreditType = this.selectCreditType.bind(this);
    this.selectNoOfCredits = this.selectNoOfCredits.bind(this);

  }
  async handleChange(comp) {
    await this.setState({ companyId: comp.value });
    this.context.viewStateStore.setCreditStates({
      companyId: comp.value,
      creditType: this.state.creditType,
    });

    //console.log(this.context.viewStateStore.creditStatesObj);

  }

  async selectCreditType(value, option) {
    await this.setState({ creditType: value })
    // if( value !== 'internet banking'){
    //   this.setState({bankSelected: ''});
    // }

    // console.log(this.context.viewStateStore.creditStates.creditType);
  }


  async selectNoOfCredits(value, option) {
    await this.setState({ credits: value })

    // console.log(this.context.viewStateStore.creditStates.creditType);
  }

  validateFile = (file) => {
    this.setState({ fileList: file });
    console.log(file);
    const allowedExtensions = [".pdf"];
    const fileName = file.name;
    const fileExtension = fileName.slice(
      ((fileName.lastIndexOf(".") - 1) >>> 0) + 2
    );
    if (!allowedExtensions.includes("." + fileExtension.toLowerCase())) {
      message.error("Only PDF files are allowed");
      return false;
    }
    const maxSize = config.photoUploadSize;
    if (file.size > maxSize) {
      message.error(this.context.translate("_FILE_SIZE_UPTO_10_MB"));
      return false;
    }
    return true;
  };
  handleRadioChange = async (e) => {
    console.log('Radio checked:', e.target.value);
    await this.setState({ bankSelected: e.target.value });
    console.log(this.state.bankSelected);
  }

  onCreditSubmit = async (fieldsValue) => {
    console.log(fieldsValue)
    console.log(this.state.receipt)
    if (this.state.receipt === '' || this.state.receipt === undefined || this.state.receipt === null) {
      message.error(this.context.translate("_CREDIT_RECEIPT_REQUIRED_"));
      return;
    }

    const data = {
      ...fieldsValue,
      paymentDate: this.state.paymentDate,
      receipt: this.state.receipt,
      createdCompanyId: this.props.getUserData().userCompanyId,
      submitAction: this.state.submitAction

    };
    console.log(data);
    const resp = await this.creditStore.requestCredit(data);

    await this.props.response(resp);

    this.setState({ loading: false });
  };

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {

      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });

      // await this.setState({userId:this.props.getUserData().userId})
      await this.setState({ isadmin: this.props.getUserData().isadmin });
    }

  }
  imageDelete = async () => {
    this.setState({ receipt: "" });
    this.creditStore.setLogoFromDb([]);
  };
  getUploadData = async (fileUp) => {
    let fileinfo = fileUp.file.response;

    console.log(fileinfo);

    if (fileinfo?.success == "S") {

      fileUp.fileList[0].url = config.fleetURL + fileinfo?.folderName;
      await this.setState({ receipt: fileinfo.data });
    }

    this.creditStore.setLogoFromDb(fileUp.fileList);
    this.setState({ update: 1 });
  };



  handleButtonClick = (action) => {
    this.setState({ submitAction: action });
  };
  render() {
    return (
      <div style={{ padding: 0 }}>
        <div style={{ paddingBottom: "10px" }}>
          {/* change style */}
          <Spin spinning={this.state.loadingSpin} fullscreen>
            <Form
              {...layout}
              ref={this.formRef}
              layout="vertical"
              name="nest-messages"
              onFinish={this.onCreditSubmit}
              className="formClass" //change
            >
              <Row className="overflowFormInputs">
                {/* css class */}
                <Col span={12} className="formColumnClass">
                  {/* css class */}





                  <Form.Item
                    name="companyDetails"
                    label={this.context.translate("_FLEET_COMPANY_COMPANYDETAIL_TITLE_")}
                    rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>

                  <Form.Item
                    name="serviceType"
                    label={this.context.translate(
                      "_SERVICE_TYPE_"
                    )}
                    rules={[{ required: true, message: this.context.translate("_SELECT_SERVICE_TYPE_") }]}
                  >
                    <Select
                      placeholder={this.context.translate(
                        "_SELECT_SERVICETYPE_"
                      )}
                      onChange={async (val, option) => {
                        await this.selectCreditType(val, option);
                      }}
                    >

                      <Select.Option value="New">
                        {this.context.translate("_NEW_")}
                      </Select.Option>
                      <Select.Option value="Renew">
                        {this.context.translate("_RENEW_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>

                  <Form.Item
                    name="contactNo"
                    label={this.context.translate("_CONTACT_NO_")}
                  //rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="emailId"
                    label={this.context.translate("_MAILID_")}
                  //  rules={[{ required: true }]}
                  >
                    <Input />
                  </Form.Item>
                  <Form.Item
                    name="receipt"
                    className="formCheckboxCss"
                    label=" "
                    style={{ marginTop: "16px" }}
                  //  valuePropName="fileList"

                  // getValueFromEvent={this.normFile}
                  >
                    <Upload
                      style={{ backgroundColor: "black" }}
                      name="receipt"
                      action={
                        config.baseURL + "/index.php?c=company&a=fileupload"
                      }
                      listType="picture"
                      accept=".pdf"
                      beforeUpload={(file) => this.validateFile(file)}
                      data={{ fileType: "creditreceipt", fieldName: "receipt" }}
                      onChange={this.getUploadData}
                      onRemove={this.imageDelete}
                      maxCount={1}
                      {...this.creditStore.logoFromDb}
                    // fileList={this.companyStore.logoFromDb}
                    // onRemove={this.removeImage}
                    // defaultFileList={[...this.companyStore.logoFromDb]}

                    >
                      <Button
                        className="imgupload"
                        icon={<UploadOutlined />}
                      >
                        {/* Upload Photo */}
                        {this.context.translate(
                          "_UPLOAD_RECEIPT_"
                        )}
                      </Button>
                    </Upload>
                  </Form.Item>

                </Col>

                <Col span={12} className="formColumnClass">
                  <Form.Item
                    name="credits"
                    label={this.context.translate(
                      "_NO_OF_CREDITS_"
                    )}
                    rules={[{ required: true, message: this.context.translate("_SELECT_NO_OF_CREDITS_") }]}
                  >
                    <Select
                      placeholder={this.context.translate(
                        "_SELECT_NOOFCREDITS_"
                      )}
                      onChange={async (val, option) => {
                        await this.selectNoOfCredits(val, option);
                      }}
                    >

                      {this.creditQuantity.map((value) => (
                        <Option key={value} value={value}>
                          {value}
                        </Option>
                      ))}
                    </Select>


                  </Form.Item>
                  <Form.Item
                    name="paymentDate"
                    // label="Date Of Birth"
                    label={this.context.translate("_PAYMENT_DATE_")}
                    rules={[{ type: Date }]}
                  >
                    <DatePicker
                      format="YYYY-MM-DD"
                      style={{ width: "100%" }}
                      defaultValue={dayjs().startOf("day")}
                      onChange={(val) => {
                        val !== null &&
                          this.setState({
                            paymentDate: val,
                          });
                      }}
                    />
                  </Form.Item>

                  <Form.Item
                    name="paymentMethod"
                    label={this.context.translate(
                      "_PAYMENT_METHOD_"
                    )}
                    rules={[{ required: true, message: this.context.translate("_SELECT_PAYMENT_METHOD_") }]}
                  >
                    <Select
                      placeholder={this.context.translate(
                        "_SELECT_PAYMENTMETHOD_"
                      )}
                      onChange={async (val, option) => {
                        await this.selectCreditType(val, option);
                      }}
                    >

                      <Select.Option value="Internet Banking">
                        {this.context.translate("_INTERNET_BANKING_")}
                      </Select.Option>
                      <Select.Option value="Debit">
                        {this.context.translate("_DEBIT_")}
                      </Select.Option>
                      <Select.Option value="Credit">
                        {this.context.translate("_CREDIT_")}
                      </Select.Option>
                    </Select>
                  </Form.Item>


                  {this.state.creditType === 'Internet Banking' && (<><Form.Item
                    style={{ marginTop: '40px' }}
                    name="selectedOption"
                  //label="Select an option"
                  // rules={[{ required: true, message: 'Please select an option!' }]}
                  >
                    <Radio.Group
                      onChange={this.handleRadioChange}
                    >
                      <div style={{ display: 'flex', gap: '16px', }}>
                        {[
                          {
                            value: 'Adib',
                            image: require("../assets/images/adib.jpg"),
                            title: 'Adib',
                          },
                          {
                            value: 'Masreq',
                            image: require("../assets/images/masreq.jpg"),
                            title: 'Masreq',
                          },
                        ].map((item) => (
                          <Radio value={item.value} key={item.value} style={{ display: 'flex', textAlign: 'center' }}>
                            <img src={item.image} alt={item.title} style={{ width: 50, height: 50, display: 'block', marginBottom: 8, display: "flex" }} />
                            <div>{item.title}</div>
                          </Radio>
                        ))}
                      </div>
                    </Radio.Group>
                  </Form.Item>
                    {this.state.bankSelected === 'Adib' && (<Form.Item>
                      <div style={{ backgroundColor: '#f5f5f5', padding: '12px', borderRadius: '8px', position: 'absolute', top: '40px', fontSize: '12px', width: '100%' }}>
                        <p><strong>Name: </strong>DRIVE SEVEN SECURITY SERVICES LLC</p>
                        <p><strong>Account number: </strong>18880601</p>
                        <p><strong>IBAN: </strong>AE720500000000018880601</p>
                        <p><strong>Bank: </strong>ABU DHABI ISLAMIC BANK (ADIB)</p>
                      </div>
                    </Form.Item>)}

                    {this.state.bankSelected === 'Masreq' && (<Form.Item>
                      <div style={{ backgroundColor: '#f5f5f5', padding: '12px', borderRadius: '8px', position: 'absolute', top: '40px', fontSize: '12px', width: '100%' }}>
                        <p><strong>Name: </strong>Mashreq Bank</p>
                        <p><strong>Account number: </strong>019100072849</p>
                        <p><strong>IBAN: </strong>AE220330000019100072849</p>
                        <p><strong>Bank: </strong>Abdulla Kunhi Moideen</p>
                      </div>
                    </Form.Item>)}
                  </>)}

                </Col>
              </Row>

              <div className="formBtnGroup">
                {/* css class */}
                <Space>
                  <Button
                    //className="formCancelButton"
                    onClick={(e) => {
                      this.props.closeModal();
                      // this.formRef.current?.resetFields();
                    }}
                  >
                    {/* css class */}
                    {/* Cancel */}
                    {this.context.translate("_FLEET_CLOSE_BTN_")}
                  </Button>
                  <Button
                    type="primary"
                    //className="formSaveButton"
                    htmlType="submit"
                    loading={this.state.loading}

                  >
                    {/* css class */}
                    {/* Save */}
                    {this.context.translate("_SUBMIT_")}
                  </Button>

                </Space>
              </div>
            </Form>
          </Spin>
        </div>

      </div>
    );
  }
}
CreditRequestAdd.contextType = StoreContext;
export default observer(withRouter(CreditRequestAdd));
